import {withJsonFormsControlProps} from '@jsonforms/react'
import component from './ReadOnlyFieldLinkText'
export default withJsonFormsControlProps(component)
